import React from "react";

interface Option<T extends string = string> {
  value: T;
  name: string;
}

interface Props<T extends string = string> {
  selectedOption: T;
  setSelectedOption: React.Dispatch<React.SetStateAction<T>>;
  options: Option<T>[];
  img?: React.ReactNode;
}

const Selection = <T extends string = string>({
  selectedOption,
  setSelectedOption,
  options,
  img,
}: Props<T>) => {
  return (
    <>
      <div className="relative / h-full w-full">
        <div
          className="absolute / left-[1.1406rem] top-0 bottom-0
                / flex justify-center items-center"
        >
          {img ? img : null}
        </div>

        <select
          className={`bg-white h-full w-full
                  / ${img ? "pl-[2.625rem]" : "pl-[15px]"} pr-8 / rounded-[8px] / border border-gray-300
                  / appearance-none focus:outline-none / text-gray-800 / font-medium`}
          name="permission"
          id="permission-select"
          value={selectedOption}
          onChange={(e) => {
            setSelectedOption(e.target.value as T);
          }}
        >
          {options.map((option) => (
            <option value={option.value}>{option.name}</option>
          ))}
        </select>

        <div
          className="absolute / right-[1.1406rem] top-0 bottom-0
                / flex justify-center items-center"
        >
          <img
            className="w-[0.6837rem]"
            alt="아래 화살표 아이콘"
            src="/assets/icons/Arrow - Down 2.svg"
          />
        </div>
      </div>
    </>
  );
};

export default Selection;
